import { environment } from '../../../../environments/environment';

/**
 * QA-эмуляция страны запроса (WEB-5842). Только не-production: на stage/dev бэкенд принимает
 * заголовок `X-Test-Country: <ISO2>` и считает его страной запроса, на prod заголовок игнорируется.
 *
 * `?test_country=BR` включает эмуляцию на сессию вкладки, `?test_country=off` (или пустое /
 * невалидное значение) выключает. Страна читается прямо из `window.location`, потому что
 * GeoStore запрашивает её в APP_INITIALIZER до старта роутера.
 */
export const TEST_COUNTRY_QUERY_PARAM = 'test_country';
export const TEST_COUNTRY_HEADER = 'X-Test-Country';
export const TEST_COUNTRY_STORAGE_KEY = 'st_test_country';

const ISO2_PATTERN = /^[A-Z]{2}$/;

/** Флаг окружения передаётся параметром, чтобы тесты могли переключать production без подмены модуля. */
export function resolveTestCountry(isProduction: boolean = environment.production): string | null {
  if (isProduction) return null;

  const fromUrl = readCountryFromUrl();

  if (fromUrl !== undefined) {
    if (fromUrl) {
      writeStoredCountry(fromUrl);
    } else {
      clearStoredCountry();
    }

    return fromUrl;
  }

  return readStoredCountry();
}

function normalizeCountry(value: string | null | undefined): string | null {
  const country = value?.trim().toUpperCase() ?? '';

  return ISO2_PATTERN.test(country) ? country : null;
}

/**
 * `undefined` — параметра в URL нет; `null` — параметр есть, но выключает эмуляцию
 * (`off`, пустой или не ISO2); строка — валидная страна в верхнем регистре.
 */
function readCountryFromUrl(): string | null | undefined {
  try {
    const params = new URLSearchParams(window.location.search);

    if (!params.has(TEST_COUNTRY_QUERY_PARAM)) return undefined;

    return normalizeCountry(params.get(TEST_COUNTRY_QUERY_PARAM));
  } catch {
    return undefined;
  }
}

function readStoredCountry(): string | null {
  try {
    return normalizeCountry(window.sessionStorage.getItem(TEST_COUNTRY_STORAGE_KEY));
  } catch {
    return null;
  }
}

function writeStoredCountry(country: string): void {
  try {
    window.sessionStorage.setItem(TEST_COUNTRY_STORAGE_KEY, country);
  } catch {
    // sessionStorage недоступен (private mode и т.п.): эмуляция живёт до смены URL
  }
}

function clearStoredCountry(): void {
  try {
    window.sessionStorage.removeItem(TEST_COUNTRY_STORAGE_KEY);
  } catch {
    // нечего очищать
  }
}
